import { commonFilter } from './filter';

const pageId = '24041';

export default {
  pageName: 'Key Opininos',
  pageId,
  pagePath: '/opinion/Overview/KeyOpinions',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    KOOS_ExcludeInvalid: {
      buttonId: '24041101',
    },
    KOOS_ChannelTypeTAB: {
      buttonId: '24041102',
    },
    KOOS_SentimentTypeTAB: {
      buttonId: '24041103',
    },
    KOOS_GotoFeeds: {
      buttonId: '24041104',
    },
    KOOS_AdvancedGPT: {
      buttonId: '24041106',
    },
    KOOS_ClickTopic: {
      buttonId: '24041107',
    },
    KOOS_HoverTopic: {
      buttonId: '24041108',
    },
    TK_keyword: {
      buttonId: '24041113',
    },
    TK_translate: {
      buttonId: '24041120',
    },
    KONO_EventsType: {
      buttonId: '24041202',
    },
    KONO_ClickTopic: {
      buttonId: '24041204',
    },
    KONO_ClickKeywords: {
      buttonId: '24041205',
    },
    KONO_Translate: {
      buttonId: '24041206',
    },
    GPT_Get_Btn: {
      buttonId: '24041105',
    },
    GPT_Confirm: {
      buttonId: '24041122',
    },
    ...commonFilter,
  },
  card: {
    TopicCard: {
      title: {
        buttonId: '24041112',
      },
      line: {
        buttonId: '24041110',
      },
      bar: {
        buttonId: '24041111',
      },
      block: {
        buttonId: '24041109',
      },
    },

    KeywordCard: {
      table: {
        buttonId: '24041117',
      },
      line: {
        buttonId: '24041116',
      },
      cloud: {
        buttonId: '24041115',
      },
      download: {
        buttonId: '24041121',
      },
    },

    KONO_Event: {
      title: {
        buttonId: '24041201',
      },
    },
    KONO_Topic: {
      title: {
        buttonId: '24041203',
      },
    },
  },
};
